import { type MenuItem } from './LivefireCard/CardMenu';
import { FeedItem } from '@/classes';
import EnvironmentHelper from '@/classes/EnvironmentHelper';

const baseStats: MenuItem = {
  label: 'View All Engagement',
  arrow: true,
  alwaysVisible: true,
  value: 'engagement',
};

const videoStats: MenuItem = {
  ...baseStats,
  value: 'videoStats',
};

const commentStats: MenuItem = {
  ...baseStats,
  value: 'commentStats',
};

const likeStats: MenuItem = {
  ...baseStats,
  value: 'likeStats',
};

const replyWithVideoPlay: MenuItem = {
  label: 'Play Video',
  arrow: true,
  alwaysVisible: true,
  value: 'replyWithVideoPlay',
};

const cardMenus = {
  /* eslint-disable camelcase */
  video_watched: [videoStats],
  reaction_like: [likeStats],
  reaction_comment: [commentStats],
  reaction_rwv: [replyWithVideoPlay],
  /* eslint-enable camelcase */
};

const onMenuItemClick = (selectedMenu: string, item: FeedItem) => {
  const idToOpen = 'videoId' in item ? item.videoId : item.id;
  const params = new URLSearchParams({
    module: 'videos',
    page: 'track',
    id: idToOpen,
  });
  const url = `${EnvironmentHelper.getAppUrl()}app?${params.toString()}`;
  switch (selectedMenu) {
    case 'videoStats':
    case 'likeStats':
    case 'commentStats':
      window.open(url, '_blank');
      return true;
    case 'replyWithVideoPlay':
      if ('replyVideoUrl' in item) {
        window.open(item.replyVideoUrl, '_blank');
      }
      return true;
  }
  return false;
};

export const videoWatchedMenuItems = {
  videoStats,
};

export const defaultMenuConfig = {
  cardMenus,
  onMenuItemClick,
};
